import { ApiClient } from '@webapp/core/services/ApiClient'
import { ApproverRepository } from './ApproverRepository'

export const approverRepository = new ApproverRepository({
  httpClient: ApiClient,
})

export { ApproverRepository }
export type { RequestableApproverParams } from './ApproverRepository'
